module.exports = __webpack_public_path__ + "img/portal-services.127fe0ec.svg";